import { render, staticRenderFns } from "./personInfor.vue?vue&type=template&id=23c7bf88&scoped=true&"
import script from "./personInfor.vue?vue&type=script&lang=js&"
export * from "./personInfor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c7bf88",
  null
  
)

export default component.exports